"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypesArray = void 0;
exports.EventTypesArray = [
    // Eventos de sesión
    "sessionConnectionCreated",
    "sessionConnectionDestroyed",
    "sessionConnected",
    "sessionDisconnected",
    "sessionReconnected",
    "sessionReconnecting",
    "sessionConecting",
    "sessionCallStatus",
    "sessionStreamCreated",
    "sessionStreamDestroyed",
    "sessionStreamPropertyChanged",
    // Eventos de publisher
    "publisherStreamDestroyed",
    "publisherAccessAllowed",
    "publisherAccessDenied",
    "publisherAccessDialogClosed",
    "publisherAccessDialogOpened",
    "publisherAudioLevelUpdated",
    "publisherDestroyed",
    "publisherMediaStopped",
    "publisherStreamCreated",
    "publisherVideoDimensionsChanged",
    "publisherVideoElementCreated",
    // Eventos de suscriptor
    "subscriberAudioBlocked",
    "subscriberAudioLevelUpdated",
    "subscriberAudioUnblocked",
    "subscriberConnected",
    "subscriberDestroyed",
    "subscriberDisconnected",
    "subscriberVideoDimensionsChanged",
    "subscriberVideoDisabled",
    "subscriberVideoDisableWarning",
    "subscriberVideoDisableWarningLifted",
    "subscriberVideoElementCreated",
    "subscriberVideoEnabled",
    "videoElementCreated",
    "joinRoomFromToast",
    "joinRoomFromQueue",
    "joinFromLink",
    "joinFromLinkWhatsapp",
    "joinFromLinkEmail",
    "joinFromLinkSms",
    "joinFromLinkNotification",
    "OT_AUTHENTICATION_ERROR",
    "OT_INVALID_SESSION_ID",
    "patientMuteCall",
];
